import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewRelatedOrganizations from './viewRelatedOrganizations';
import viewRelatedUserPermissions from './viewRelatedUserPermissions';

const defaultActivationDate = new Date();
const defaultExpirationDate = new Date();
defaultExpirationDate.setFullYear(defaultExpirationDate.getFullYear() + 10);
export default {
  title: 'General values',
  attributeName: 'user',
  fields: [
    {
      attributeName: 'name',
      helpText: 'Name of the user',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Name',
      placeholder: 'Name...',
    },
    {
      attributeName: 'email',
      type: FormInputTypes.TEXT_INPUT.EMAIL,
      helpText: 'Email of the user',
      label: 'Email of the user ',
      placeholder: 'Email...',
    },
    {
      attributeName: 'password',
      type: FormInputTypes.TEXT_INPUT.PASSWORD,
      helpText: 'Password of the user',
      label: 'Password',
      placeholder: 'Enter password...',
      avoidAutofill: true
    },
    {
      attributeName: 'password_confirmation',
      type: FormInputTypes.TEXT_INPUT.PASSWORD,
      helpText: 'Repeat the password',
      label: 'Repeat password ',
      placeholder: 'Repeat password...',
      avoidAutofill: true
    },
    {
      attributeName: 'permissions',
      label: 'Permissions',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      configFile: viewRelatedUserPermissions,
      default: [],
      helpText: 'Add permission to user',
    },
   /* {
      attributeName: 'roles',
      label: 'Roles',
      type: FormInputTypes.RELATIONSHIP,
      canEdit: true,
      canCreate: true,
      configFile: viewRelatedUserRole,
      default: [],
      helpText: 'Add role to user',
    },*/
    {
      attributeName: 'organization',
      label: 'Organization',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: false,
      canCreate: true,
      configFile: viewRelatedOrganizations,
      default: [],
      helpText: 'Asign an organization to this user',
      disabledWhenEdit: true,
    },
    {
      attributeName: 'isTesting',
      label: 'Testing',
      type: FormInputTypes.CHECKBOX,
      helpText: 'Indicate if this user is a tester, this user is not considered for some internal XMS processes',
    },
  ],
};
